import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VAutocomplete,{attrs:{"outlined":"","items":_vm.departments,"label":_vm.field.text,"item-value":"id","item-text":"name","rules":_vm.validators,"append-icon":"mdi-chevron-down","dense":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []

export { render, staticRenderFns }